import "./registerServiceWorker";
import { setPWAPrompt } from "@/lib/pwa";
import { applyPolyfills } from "@/modules/polyfills";
import createApp from "@/main";

setPWAPrompt();

applyPolyfills()
  .then(() => createApp())
  .then(({ app }) => app.$mount("#app"));
